import io from 'socket.io-client';
import { state, socketId } from "../store";

const socket = io();
let oldState = null;
state.subscribe((value) => {
	oldState = value;
});

let myId = "";

socketId.subscribe(value => {
	myId = value;
});

socket.on("id", (id) => {
	if (!myId) {
		myId = id;
		socketId.set(id);
	}
	socket.emit("join", myId);
});

socket.on("state", (newState) => {
	console.log(newState);
	const player = newState.players.find((player) => {
		return player.id === myId;
	});
	if (!player) {
		const isSpectator = newState.spectators.find((player) => {
			return player.id === myId;
		}) !== undefined;

		if (!isSpectator) {
			socket.emit("join", myId);
		}
		else {
			state.set(newState);
		}
	}
	else {
		player.isYou = true;

		if (oldState && oldState.game && oldState.game.centerCards) {
			if (oldState.game.centerCards.length < newState.game.centerCards.length) {
				const card = newState.game.centerCards.find((card) => {
					return oldState.game.centerCards.indexOf(card) === -1;
				});

				if (card) {
					const player = oldState.players.find((player) => {
						return player.cards.indexOf(card) !== -1;
					});

					if (player) {
						newState.changeCard = {
							card,
							to: "center",
							from: player,
						};
					}
				}
			}
			else if (oldState.game.centerCards.length > newState.game.centerCards.length) {
				const card = oldState.game.centerCards.find((card) => {
					return newState.game.centerCards.indexOf(card) === -1;
				});

				if (card) {
					const player = newState.players.find((player) => {
						return player.cards.indexOf(card) !== -1;
					});

					if (player) {
						newState.changeCard = {
							card,
							from: "center",
							to: player,
						};
					}
				}
			}
		}

		state.set(newState);
	}
});

export const action = (actionName, data) => {
	socket.emit(actionName, data);
};
